import React from 'react';

/**
 * Crédito de autoria no rodapé das telas internas: "Desenvolvido por BzR Tech".
 *
 * Fica discreto de propósito — é assinatura, não conteúdo; não pode disputar
 * atenção com a tela de trabalho do professor.
 *
 * Fecha com o Bloco, a assinatura da BzR (Manual de Marca, cap. 01): um
 * quadrado verde #008037 com um único canto arredondado, sempre o superior
 * direito. "Sólido constrói; piscando respira" — no fim da linha ele pisca
 * como cursor de terminal (a animação `bzr-pisca`, em index.css, segue o
 * bzr-cursor.gif da marca: 600 ms aceso, 500 ms apagado). Sem degradê, sem
 * sombra, a cor não muda com o tema. Pisca sempre, mesmo com "menos
 * movimento" ligado no sistema — decisão da BzR: o Bloco é pequeno e fica
 * fora da área de trabalho.
 */
function CreditoBzR({ darkMode, className = '' }) {
  return (
    <p
      className={`flex items-center justify-center gap-1 text-xs ${
        darkMode ? 'text-slate-500' : 'text-slate-400'
      } ${className}`}
    >
      <span>
        Desenvolvido por{' '}
        <span className={`font-semibold ${darkMode ? 'text-slate-400' : 'text-slate-500'}`}>
          BzR Tech
        </span>
      </span>
      <span
        aria-hidden="true"
        className="inline-block w-[0.6em] h-[0.85em] bg-[#008037] animate-[bzr-pisca_1.1s_step-end_infinite]"
        // Proporção e canto do cursor da marca: raio de 1/5 da largura.
        style={{ borderRadius: '0 0.12em 0 0' }}
      />
    </p>
  );
}

export default CreditoBzR;
